<nav class="navbar main-navbar" >

    <div class="container-fluid">

      <a routerLink="/" class="navbar-brand">

        <img
          alt="Info Motel"
          src="../../../assets/img/logos-novas/infomotel-gestor_2019_fundo-escuro2x_novo.png"
          class="img-responsive"
          style="height: 40px;"
        >

      </a>

      <button class="navbar-toggler" (click)="minimizeSideBar()">

        <span class="navbar-toggler-icon"></span>

      </button>

    </div>

  </nav>
